import { ReactElement, useState } from 'react';
import RadioButton from 'components/shared/RadioButton';
import SkipMenuSurvey from 'models/SkipMenuSurvey';
import { Component as EditBox } from 'icons/icon-circle-lime--edit-box.svg';
import { post } from 'utils/network';
import { ApiRoute } from 'config';
import { Modal } from './Modal';
import { Button } from '../button/Button';
import styles from './Modal.module.scss';

type Props = {
    isOpen: boolean;
    onClose: () => void; // closes survey out (does not include submit logic)
    menuId: number;
};

export function SkipSurveyModal({ isOpen, onClose, menuId }: Props): ReactElement {
  const surveyOptions = SkipMenuSurvey.getOptionsV2();
  const [selectedOption, setSelectedOption] = useState(null);
  const [otherValue, setOtherValue] = useState('');

  const onSelectionChange = (e) => setSelectedOption(e.target.id);
  const onOtherValueChange = (e) => setOtherValue(e.target.value);

  const submitAndClose = () => {
    post(ApiRoute.SKIP_MENU_SURVEY, {
      menu_id: menuId,
      skip_menu_survey: {
        reason: selectedOption,
        other_reason: selectedOption === 'other' ? otherValue : undefined,
        survey_type: 'order',
      },
    })
      .then((r) => {
        if (!r.ok) {
          console.error('Skip survey error', r);
        }
      });

    onClose();
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={(
          <div className={styles.skip_survey_modal__title}>
            <EditBox className={styles.skip_survey_modal__icon} />
            Tell us more
          </div>
        )}
        classNames={{
          close: styles.skip_survey_modal__close_button,
        }}
      >
        <div className={styles.skip_survey_modal}>
          <form onSubmit={(e) => e.preventDefault()}>
            <fieldset className="c-form-group">
              <div className={styles.subtitle}>
                Why did you choose to skip your Purple Carrot delivery?
              </div>
              {surveyOptions.map((option) => (
                <RadioButton
                  key={option.id}
                  id={option.id}
                  label={option.label}
                  name="reason"
                  onChange={onSelectionChange}
                />
              ))}
            </fieldset>
            <div className="c-form-group string">
              {selectedOption === 'other' && (
                <input
                  id="other_reason"
                  placeholder="Please specify"
                  type="text"
                  value={otherValue}
                  onChange={onOtherValueChange}
                />
              )}
            </div>
          </form>
          <Button
            className={`c-button c-button--primary ${styles.submit_button}`}
            onClick={submitAndClose}
            isEnabled={!(selectedOption === null
                  || (selectedOption === 'other'
                      && otherValue === ''))}
            text="Submit"
          />
        </div>
      </Modal>
    </>
  );
}
